<template>
   <div class="row">
        <div class="col-md-12">
            <text-button-field
                v-model="textSearchTerm"
                property="searchname"
                name="Rechercher"
            />
        </div>                
    </div>
</template>
<script>
import { TextButtonField } from '@/core/components/form';
import {mapActions, mapState} from "vuex";

export default {
    name: 'FilterProduct',
    components:{
        TextButtonField,
    },
    computed:{
        ...mapState('crudList',['list']),
        ...mapState('products', ['products'])
    },
    methods:{
        ...mapActions('crudList',['loadList'])
    },
    watch:{
        textSearchTerm(val,old){
            let filteredList = []
            if(val !== old){
                filteredList = this.list.filter(item => {
                    if(item.name.toLowerCase().includes(val.toLowerCase())) return item
                })
            }
            if(val !== "" && filteredList.length != 0) this.loadList(filteredList)
            else this.loadList(this.products)
        }
    },
    data(){
        return {
            textSearchTerm:''
        }
    }
}
</script>